(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SessionTypeDialogController', SessionTypeDialogController);

    SessionTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SessionType'];

    function SessionTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SessionType) {
        var vm = this;

        vm.sessionType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sessionType.id !== null) {
                SessionType.update(vm.sessionType, onSaveSuccess, onSaveError);
            } else {
                SessionType.save(vm.sessionType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:sessionTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
